import React from "react";
import { __ } from "@wordpress/i18n";
import { Section } from "../section";
import { PluginCard } from "./plugin-card";
import { getUtmUrl } from "../../utils/utm-url";

// Access the localized pro plugins data
const PRO_PLUGINS_OBJ = window.wpmudev_cross_sell_data.pro_plugins || [];
const PRO_PLUGINS = Object.values(PRO_PLUGINS_OBJ);

const PluginsPro = () => {
  return (
    <Section
      title={__(
        "Get a high-powered web-building suite, at no extra cost",
        "plugin-cross-sell-textdomain"
      )}
      className="cross-sell-plugins--pro"
    >
      {PRO_PLUGINS.length > 0 && (
        <div className="cross-sell-grid">
          {PRO_PLUGINS.map((plugin) => (
            <PluginCard key={plugin.slug} as="a" {...plugin} />
          ))}
        </div>
      )}
      <div className="cross-sell-text-center">
        <a
          role="button"
          href={getUtmUrl("https://wpmudev.com/plugins/", {utm_campaign:'cross-sell_plugin_all-plugins'})}
          target="_blank"
          className="sui-button sui-button-ghost"
        >
          {__("View all pro plugins", "plugin-cross-sell-textdomain")}
        </a>
      </div>
    </Section>
  );
};

export { PluginsPro };
